/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {Schema} from 'common/yup';

// https://github.com/jquense/yup/issues/662#issuecomment-549593609
export function oneOf<T extends Schema<any>>(tries: T[]) {
   return yup.mixed().when('.', (current: any) => {
      for (const t of tries) {
         try {
            t.validateSync(current, {
               strict: true,
            });
            return t;
         } catch (e) {} // discard
      }

      return yup
         .mixed()
         .test('oneOf-failure', 'No alternatives for oneOf were successful', (v) => false);
   });
}
